import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import FavoriteTeam from '../components/Profile/FavoriteTeam';
import UserFavoritedTeams from '../components/Profile/UserFavoritedTeams';
import { firestore } from '../firebase'
import StateContext from '../StateContext';

function TeamsPage() {

    const appState = useContext(StateContext)


    const [teams, setTeams] = useState([])

    useEffect(() => {
        
        try {
            const teamsRef = firestore.collection("teams");
            teamsRef.orderBy("team_name").onSnapshot(({docs}) => {
                const teams = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setTeams(teams);
            })
        } catch (error) {
            
        }

    }, [])

    return (
        <div className="container">
            
            {appState.loggedIn && (
                <div>
                    <div className="card card-header mt-3"><h4 className="font-weight-bold">FavorittLag</h4></div>
                    <UserFavoritedTeams />
                </div>
            )}
            <div className="card card-header mt-3"><h4 className="font-weight-bold">Alle lag</h4></div>
            {teams && teams.map((team, index) => {
                return (
                    <div key={index} className="card card-body" >
                        <div className="row">
                            <div className="col-10">
                                <Link to={`/teams/${team.id}`}>
                                    <img src={team.team_logo} style={{maxWidth: "40px"}} />
                                    <span> {team.team_name}</span>
                                </Link>
                            </div>

                            <div className="col-2">
                                {appState.loggedIn && (
                                    <div className="float-right">
                                        <FavoriteTeam team={team} teamId={team.id} />
                                    </div>
                                )}

                            </div>

                        </div>
                        
                        
                    </div>
                )
            })}
        </div>
    )
}
export default TeamsPage